
// 항상 FixedDetail 프레임 안에 존재한다.
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import { ajaxor2 } from '../../common/basic';

import ImageScroller from "./PictureScroller";
import Informations from "./Informations";
import InfoPersonM from './InfoPersonM';

export default props=>{
    // console.log("Detail.js props.me: ",props.me);
    if (!props.me) {
        return <></>;
    }

    /*
    이걸로 안돌아가고 프롭스로 돌아간다.
    const initCID = useRouter().query.cid;
    const [vCID, setCID] = useState(initCID);
    useEffect(()=>{
        if (!process.browser || vCID == undefined )return;
        ajaxor2({
            url: "/inspiration/single/" + vCID, // 컨텐츠 상세정보
            callback: r => console.log('response',r)
        });
    }, [vCID]);
    */
    
    return (<div className="this-content">
        <style jsx>{`
.this-content{
    height: 100%;
}

.x2{
    float: right;
    margin: 20px;
}

.narrow-content{
    /* padding: 15px; */
    box-sizing: border-box;
    height: 100%;

}

.leftside{
    width: 130px;
    vertical-align: top;
    position: fixed;
    top: 545px;
    right: calc( 50% + 610px );
    text-align: center;
}

.informations{
    overflow-y: overlay;
    overflow-x: hidden;
    width: 440px;

    position: fixed;
    top: 100px;
    left: calc(50% + 56px);
    bottom: 30px;
}

.rightside{    
    width: 130px;
    position: fixed;
    top: 545px;
    left: calc( 50% + 610px );
    text-align: center;

}

.pictures{
    width: 570px;
    overflow-y: auto;
    /* vertical-align: top; */

    position: fixed;
    top: 100px;
    right: calc(50%);
    bottom: 30px;

}

.pictures::-webkit-scrollbar{
    display: none; 
}


.informations::-webkit-scrollbar{
    display: none; 
}


@media all and (max-width:606px) {
    .leftside{
        display: none;
    }
    .rightside{
        display: none;
    }


    .pictures, .informations{
        width: 100%;
        position: initial;
    }

    .narrow-content{
        box-sizing: border-box;
        padding: 0 16px;
    }


    .pictures{
        height: 100%;
    }

}


`}</style>
        <a onClick={props.hide}><img className="x2 dibom" src="/assets/images-m/x_2.svg" /></a>
        <div className="narrow-content">
            <div className="dib leftside">
                <a 
                    onClick={() => props.move(props.index - 1)} 
                    style={{ display: props.index > 0 ? 'block' : 'none' }} 
                ><img src="/assets/images/group-8_2.svg" /></a>
            </div>
            <InfoPersonM me={props.me} likePlus={props.likePlus} />{/* 모바일전용 */}

            <div className="dib pictures">
                <ImageScroller me={props.me.images} />
            </div>
            <div className="dib informations">
                <Informations me={props.me}
                    moveLeft={() => props.move(props.index - 1)} 
                    moveRight={() => props.move(props.index + 1)}
                    likePlus={props.likePlus}
                />
            </div>
            <div className="dib rightside">
                <a 
                    onClick={() => props.move(props.index+1)} 
                    style={{ display: (props.index < props.maxListSize-1) ? 'block' : 'none' }} 
                ><img src="/assets/images/group-8.svg" /></a>
            </div>
        </div>

    </div>);
}